export default "__VITE_ASSET__ewJGG3ca__"